import { ShoppingBag, ExternalLink } from "lucide-react";

const SHOP_URL = "https://www.beckylisscosmetics.com/";

export const BackToShop = () => (
  <a
    href={SHOP_URL}
    target="_blank"
    rel="noopener noreferrer"
    aria-label="Retour à la boutique Beckyliss"
    className="back-to-shop fixed bottom-6 right-6 z-40"
    data-testid="back-to-shop"
  >
    <span className="back-to-shop-pill flex items-center gap-3 bg-bl-text text-bl-bg pl-5 pr-6 py-3.5 shadow-2xl rounded-full border border-bl-dore">
      <ShoppingBag size={18} strokeWidth={1.5} className="text-bl-dore" />
      <span className="font-serif italic text-base whitespace-nowrap tracking-wide">
        Retour à la boutique
      </span>
      <ExternalLink size={14} strokeWidth={1.5} className="opacity-70" />
    </span>
  </a>
);
